import Provider from "../../Provider";

import FetchSettings from "../../../interfaces/FetchSettings";
import {
  CategoryJsonPage,
  DiscussionJsonPage,
} from "../../../interfaces/JsonPage";
import {
  VanillaApiTag,
  VanillaDiscussion,
  VanillaCategory,
} from "../../../interfaces/VanillaApi";
import { getMode } from "../../../utilities";

export default class LocalProvider extends Provider {
  protected baseUrl = process.env.VANILLA_API_URL;

  /* ***** DEV ***** */
  // CATEGORY
  categoryId = 86;
  categoryName = "Test Idea-category";
  urlCode = "test-idea-category";
  allowedDiscussionTypes = ["Discussion", "Question", "Idea"];

  // DISCUSSION
  // discussionId = 119; // With epic created.
  discussionId = 206; // Without epic created.
  discussionType = "Idea";
  discussionTags = {
    Status: [
      {
        Name: "Planned",
      },
    ],
  };
  /* ***** /DEV ***** */

  /* ***** UAT ***** */
  // // CATEGORY
  // categoryId = 42;
  // categoryName = "Sales";
  // urlCode = "cx-sales";
  // allowedDiscussionTypes = ["Discussion", "Question"];

  // // DISCUSSION
  // discussionId = 37120;
  // discussionType = "Idea";
  // discussionTags = {
  //   Status: [
  //     {
  //       Name: "Under Oracle Review",
  //     }
  //   ]
  // };
  /* ***** /UAT ***** */

  /* ***** PROD ***** */
  // // CATEGORY
  // categoryId = 667;
  // categoryName = "Multicloud ODSA";
  // urlCode = "oci-multicloud-odsa";
  // allowedDiscussionTypes = [
  //   "Discussion",
  //   "Question"
  // ];
  /* ***** /PROD ***** */

  catJsonPage: CategoryJsonPage = {
    CategoryID: this.categoryId,
    // Category: {
    //   CategoryID: this.categoryId,
    //   Name: this.categoryName,
    //   UrlCode: this.urlCode,
    //   AllowedDiscussionTypes: this.allowedDiscussionTypes,
    // },
    Category: null, // To test general discussion creation.
  };

  discussionJsonPage: DiscussionJsonPage = {
    Discussion: {
      DiscussionID: this.discussionId,
      Type: this.discussionType,
      XTags: this.discussionTags,
    },
    Category: {
      CategoryID: this.categoryId,
      Name: this.categoryName,
      UrlCode: this.urlCode,
      AllowedDiscussionTypes: this.allowedDiscussionTypes,
    },
  };

  async getCategoryFromJsonPage(): Promise<CategoryJsonPage> {
    return this.catJsonPage;
  }

  public async getCategory(
    categoryId: number
  ): Promise<VanillaCategory | null> {
    const url = new URL(this.baseUrl + "categories/" + categoryId);
    const settings: FetchSettings = {
      method: "GET",
    };
    const data: VanillaCategory = await this.request(url.toString(), settings);
    return data;
  }

  async getDiscussionFromJsonPage(): Promise<DiscussionJsonPage | null> {
    return this.discussionJsonPage;
  }

  public async getDiscussion(
    discussionId: number
  ): Promise<VanillaDiscussion | null> {
    console.log("Discussion id filter", discussionId);
    const url = new URL(this.baseUrl + "discussions/" + discussionId);
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const data: VanillaDiscussion = await this.request(
      url.toString(),
      settings
    );
    return data;
  }

  public async getTags(
    filter: Array<string> = []
  ): Promise<Array<VanillaApiTag>> {
    console.log("  Getting tags", filter.join("&"));
    const url = new URL(this.baseUrl + "tags");
    const headers = new Headers();
    if (getMode() === "development") {
      headers.append(
        "Authorization",
        "Bearer " + process.env.VANILLA_API_TOKEN
      );
    }
    const settings: FetchSettings = {
      method: "GET",
      headers: headers,
    };
    const tags: Array<VanillaApiTag> = await this.request(
      url.toString() + "?" + filter.join("&"),
      settings
    );
    return tags;
  }
}
